import { MapPin, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PHONE_DISPLAY, PHONE_TEL } from "@/constants/site";

const places = [
  "Novara e provincia",
  "Milano e provincia",
  "Altre zone su richiesta: chiedici senza impegno",
];

export default function ServiceArea() {
  return (
    <section id="zona" data-testid="service-area-section" className="border-b border-slate-200 bg-white py-24">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-6 lg:grid-cols-2">
        <div>
          <p className="text-sm font-bold uppercase tracking-widest text-orange-500">Zona servita</p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
            Novara, Milano e province
          </h2>
          <p className="mt-4 max-w-lg text-base text-slate-600 md:text-lg">
            Operiamo a Novara e provincia e a Milano e provincia. Per lavori in altre zone
            chiedici senza impegno: ti diciamo subito tempi e costi.
          </p>
          <ul className="mt-8 space-y-4" data-testid="area-list">
            {places.map((p) => (
              <li key={p} className="flex items-center gap-3 text-base font-medium text-slate-800">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-orange-50 text-orange-500">
                  <MapPin className="h-5 w-5" />
                </span>
                {p}
              </li>
            ))}
          </ul>
        </div>
        <div className="rounded-lg border border-slate-200 bg-slate-900 p-10 text-center lg:p-14">
          <p className="font-display text-2xl font-semibold text-white">Non sei sicuro che arriviamo da te?</p>
          <p className="mt-3 text-slate-300">Chiamaci: in due minuti ti diciamo tempi e costi per la tua zona.</p>
          <Button
            asChild
            size="lg"
            data-testid="area-call-button"
            className="mt-8 rounded-md bg-orange-500 px-8 font-semibold text-white transition-transform duration-200 hover:scale-[1.03] hover:bg-orange-600"
          >
            <a href={PHONE_TEL}>
              <Phone className="mr-2 h-5 w-5" /> {PHONE_DISPLAY}
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
}
